var _excluded = ["className", "children", "col", "offset", "borderTop", "borderBottom", "borderLeft", "borderRight", "gray", "utils"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import StyledGridColumn from './grid.column.styles';
import { StyledCacheWrapper } from '../../../../styles';
var GridColumnProps = {
  /** Add custom CSS classes to component. */
  className: PropTypes.string,
  /** Grid Content */
  children: PropTypes.node,
  /** Size of the column.<br /><br />
   * **sm** -  min-width : 0px <br />
   * **md** - min-width : 768px <br />
   * **lg** - min-width : 1024px <br />
   * **xl** - min-width : 1200px
   */
  col: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  /** Sets the offset position of a column. */
  offset: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object]),
  /** Adds left border to column. */
  borderLeft: PropTypes.bool,
  /** Adds right border to column. */
  borderRight: PropTypes.bool,
  /** Applies the top border to the column. */
  borderTop: PropTypes.bool,
  /** Applies the bottom border to the column. */
  borderBottom: PropTypes.bool,
  /** Sets the background for the column to gray. */
  gray: PropTypes.bool,
  /** Add utility props for styling */
  utils: PropTypes.object
};
var GridColumnPropsDefault = {
  className: '',
  children: null,
  col: 12,
  offset: null,
  borderBottom: false,
  borderTop: false,
  borderLeft: false,
  borderRight: false,
  gray: false,
  utils: {}
};
var GridColumn = function GridColumn(props) {
  var className = props.className,
    children = props.children,
    col = props.col,
    offset = props.offset,
    borderTop = props.borderTop,
    borderBottom = props.borderBottom,
    borderLeft = props.borderLeft,
    borderRight = props.borderRight,
    gray = props.gray,
    utils = props.utils,
    other = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(StyledCacheWrapper, null, /*#__PURE__*/React.createElement(StyledGridColumn, _extends({}, other, {
    borderBottom: borderBottom,
    borderLeft: borderLeft,
    borderRight: borderRight,
    borderTop: borderTop,
    className: className,
    cols: col,
    offset: offset,
    isGray: gray,
    utils: utils
  }), children));
};
GridColumn.propTypes = GridColumnProps;
GridColumn.defaultProps = GridColumnPropsDefault;
GridColumn.displayName = 'Grid.Column';
export default GridColumn;